import { Component } from '@angular/core';
import { BaseDetailPageComponent } from 'src/app/components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from 'src/app/models/base-detail-page.config';
import { JurisdictionsService } from 'src/app/services/api/general-settings/jurisdictions.service';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { CommonService } from 'src/app/services/common.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-projects-checklist-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './projects-checklist-detail-page.component.html',
  styleUrl: './projects-checklist-detail-page.component.scss'
})
export class ProjectsChecklistDetailPageComponent {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyChecklistDetail: boolean

  checklist?: any;

  constructor(
    private projectsService: ProjectsService,
    private routeService: RouteService,
    private commonService: CommonService
  ) {
    this.readonlyChecklistDetail = true
  }

  ngOnInit(): void {

    this.baseDetailPageConfig = {
      pageTitle: 'Checklist',
      cardTitle: 'Checklist Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Checklist',
        onClick: () => {
          this.routeService.projectsSettingsChecklistUpdate(this.checklist?.checklistId)
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'Id',
            label: 'ID',
            value: (item: any) => {
              return item.checklistId;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },          
          {
            attribute: 'details',
            label: 'Details',
            value: (item: any) => {
              return item.details;
            }
          },
          {
            attribute: 'createTime',
            label: 'Create Time',
            value: (item: any) => {
              return this.formatCreateTime(item.createTime);
            }
          },
        ]
      },
      apiDetailService: (checklistId: any) => this.projectsService.detailSettingsChecklist(checklistId),
      routeParamName: 'checklistId',
      responseModelName: 'checklist'
    };

  }

  onLoadedDetail(data: any) {
    this.checklist = data;
  }

  private formatCreateTime(date: any): string {
    if (!date) return '';
    
    try {
      const dateObj = typeof date === 'string' ? new Date(date) : date;
      
      if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) {
        return '';
      }

      return this.commonService.formatDate(dateObj);
    } catch (error) {
      console.warn('Errore nella formattazione della data:', error);
      return '';
    }
  }
}
